export default __webpack_public_path__ + "static/media/emailIcon.9007543a.svg";